import React, { useEffect, useLayoutEffect, useState } from "react";
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Image,
  Input,
  Menu,
  Modal,
  Row,
  Select,
  message,
  Tooltip,
  Alert,
} from "antd";
import AuthService from "../../../Components/auth/AuthService";
import config from "../../../Components/config";
import { DATE_FORMAT, DriverReminderTasks } from "../../../Components/common/constants";
import dayjs from "dayjs";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button as UploadButton, IconButton } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import qs from "query-string";
import { hideLoading, showLoading, useLoadingDispatch } from "../../../context/loadingContext";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";

const Auth = new AuthService();

const ResolveDriverReminder = () => {
  const { Option } = Select;
  const { TextArea } = Input;
  const navigate = useNavigate()
  const params = useParams();
  const [id, setId] = React.useState(params.id ? params.id : 0);
  var layoutDispatch = useLoadingDispatch();

  const currentDate = new Date();
  const [selectedDriver, setSelectedDriver] = React.useState(null);
  const [selectedTask, setSelectedTask] = React.useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [dueDateNext, setDueDateNext] = useState(null);
  const [completionDate, setCompletionDate] = useState(currentDate);
  const [thresholdDays, setThresholdDays] = useState('');

  const [files, setFiles] = useState([]);
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = React.useState([]);
  const [notes, setNotes] = React.useState("");
  const [currentRecord, setCurrentRecord] = React.useState("");


  const [allDrivers, setAllDrivers] = React.useState([]);


  const getAllDrivers = async () => {
    showLoading(layoutDispatch);
    try {
      const response = await Auth.fetch(`/driver/drivers`);
      if (response) {
        hideLoading(layoutDispatch);
        if (response?.ack) {
          setAllDrivers(response.drivers);
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  useLayoutEffect(()=> {
    getAllDrivers()
  },[])


  const getDataByID = async () => {
    showLoading(layoutDispatch)
    try {
        const res = await Auth.fetch(`/reminder/reminder-driver?id=${id}`)
        if(res?.ack) {
            setSelectedDriver(res?.reminder?.driver_id);
            setSelectedTask(res?.reminder?.type)
            setDueDate(res?.reminder?.due_date ? new Date(res?.reminder?.due_date) : null)
            setCurrentItemFiles(res?.reminder?.files ? JSON.parse(res?.reminder?.files) : [])
            setNotes(res?.reminder?.notes || '')
            setCurrentRecord(res?.reminder)
        }
    } catch (err) {
        console.log(err);
    } finally {
        hideLoading(layoutDispatch)
    }
  }

  useEffect(()=>{
    if(id > 0) {
    getDataByID()
    }
  },[])



useEffect(() => {
    if (selectedTask && completionDate) {
      const interval = DriverReminderTasks.filter((item)=> item.id === selectedTask);
      if (interval) {
        const nextDueDate = dayjs(completionDate).add(interval[0].interval || 0, interval[0].intervalType);
        setDueDateNext(nextDueDate.toDate());
        setThresholdDays(interval[0].thresholdDays)
      }
    }
  }, [selectedTask, completionDate]);  


  const handleOk = async () => {
    const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
    if(isEmptyOrUndefined(completionDate)) {
    message.error('Please enter completion date')
    return;
    }
    showLoading(layoutDispatch);
    const dataToSend = {
      reminder : currentRecord, 
      files: currentItemFiles,
      notes: notes,
      next_due_date: dueDateNext ? moment(dueDateNext).format('YYYY-MM-DD') : null,
      completion_date: completionDate ? moment(completionDate).format('YYYY-MM-DD') : null
    }
    try {
      const res = await Auth.fetch("/reminder/resolve-reminder-driver", {
        method: "POST",
        body: JSON.stringify(dataToSend),
      })
      if(res?.ack) {    
        const uploadPromises = []
        if (files.length > 0) {
          files.forEach((f) => {
            uploadPromises.push(
              getUploadUrl(f, id)
                .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
                .catch(error => console.error("Error uploading file:", error))
            );
          });
        }
        await Promise.all(uploadPromises);    
        message.success(res?.message)
        navigate('/driver_reminder')
      } else {
        message.error(res?.message)
      }

    } catch (err) {
      console.log(err);
    } 
    finally {
    hideLoading(layoutDispatch);
    }
  };


  useEffect(() => {
    message.config({
      top: window.innerHeight - 100, 
      duration: 3, 
    });
  }, [])

  const getThresholdDisplay = (thresholdDays) => {
    const weeks = thresholdDays / 7;
    const months = thresholdDays / 30;
  
    if (Number.isInteger(weeks)) {
      return `${weeks} week${weeks > 1 ? 's' : ''}`;
    } else if (Number.isInteger(months)) {
      return `${months} month${months > 1 ? 's' : ''}`;
    } else {
      return `${thresholdDays} day${thresholdDays > 1 ? 's' : ''}`;
    }
  };

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${
        file.name.split(".")[1]
      }`;
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const getUploadUrl = async (file, recordID) => {
    const params = {
      bucket: config.tms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/reminders-driver/" + recordID + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };

  const disabledDate = (current) => {
    return current && current < dayjs().startOf('day');
  };

  return (
    <>
      <div>
      <div>
            <h3>Resolve Driver Reminder</h3>
        </div>
        <>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Driver<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              disabled
              value={selectedDriver}
              placeholder="Please Select"
              onChange={(value) => {
                setSelectedDriver(value);
              }}
            >
              {allDrivers.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.driver_name}
                </Option>
              ))}
            </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Tasks<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              disabled
              value={selectedTask}
              placeholder="Please Select"
              onChange={(value) => {
                setSelectedTask(value);
              }}
            >
              {DriverReminderTasks.map((item) => (
                <Option key={item.id} value={item.id}>
                  {item.title}
                </Option>
              ))}
            </Select>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
              Due Date<span style={{ color: "red", fontSize: "15px" }}>*</span>:
            </span>
            <DatePicker
              format={DATE_FORMAT}
              disabled
              value={dueDate ? dayjs(dueDate) : null}
               onChange={(date) => {
                const nativeDate = date ? date.toDate() : null;
                setDueDate(nativeDate);
              }}
              style={{
                width: "100%",
              }}
              placeholder="Select date"
            />
            </Col>
            
          </Row>
          <Row style={{marginTop: '5px'}} gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <span>
             Completion Date<span style={{ color: "red", fontSize: "15px" }}>*</span>:
            </span>
            <DatePicker
              format={DATE_FORMAT}
              value={completionDate ? dayjs(completionDate) : null}
               onChange={(date) => {
                const nativeDate = date ? date.toDate() : null;
                setCompletionDate(nativeDate);
              }}
              style={{
                width: "100%",
              }}
              placeholder="Select date"
              // disabledDate={disabledDate}
            />
            </Col>
          </Row>
          <Row style={{marginTop: '5px'}} gutter={[16, 16]}>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <span>
              Notes:
            </span>
                <TextArea value={notes} onChange={(e)=> setNotes(e.target.value)} autoSize={{ minRows: 3, maxRows: 6 }} />
            </Col>
          </Row>
          <Divider />
          <>
          <div>
        <UploadButton
          component="label"
          variant="contained"
          sx={{ marginTop: "10px" }}
          startIcon={<CloudUploadIcon />}
        >
          Add files
          <input
            type="file"
            hidden
            multiple
            capture
            // onChange={(e) => {
            //   handleSubmitImage(e);
            // }}
            onChange={(e) => {
                          const myfiles = e.target.files;
                          if (myfiles.length > 10) {
                            message.error("A maximum of 10 images can be uploaded at a time.");
                            e.target.value = "";
                          } else {
                            handleSubmitImage(e);
                          }
                        }}
          />
        </UploadButton>
      </div>
      {currentItemFiles?.length > 0 && <h4>Old Files:</h4>}
      <ul>
                  {currentItemFiles?.length > 0 &&
                    currentItemFiles
                      .filter(
                        (item) =>
                          !files.some((file) => file.name === item)
                      )
                      .map((item) => {
                        const lastHyphenIndex = item.lastIndexOf("-");
                        const dotBeforeExtensionIndex = item.lastIndexOf(".");
                        const newFileName =
                          item.slice(0, lastHyphenIndex) +
                          item.slice(dotBeforeExtensionIndex);
                        return (
                          <li>
                                <IconButton
                                  aria-label="delete"
                                  color="primary"
                                  onClick={() => handleDeleteCurrentFile(item)}
                                >
                                  <DeleteIcon />
                                </IconButton>

                            <a
                              href={`${config.tms_uploads_cdn}/${config.env}/reminders-driver/${id}/${item}`}
                              target="_blank"
                            >
                              {newFileName}
                            </a>
                          </li>
                        );
                      })}
                </ul>
      {/* <Image.PreviewGroup>
        {currentItemFiles?.length > 0 &&
          currentItemFiles
            .filter((item) => !files.some((file) => file.name === item))
            .map((item) => {
              const imageUrl = `${config.tms_uploads_cdn}/${config.env}/reminders-driver/${id}/${item}`;
              return (
                <div
                  style={{
                    position: "relative",
                    marginRight: "10px",
                    display: "inline-block",
                  }}
                >
                  <Image
                    width={200}
                    height={150}
                    style={{ padding: "5px", border: "1px solid lightgrey" }}
                    src={imageUrl}
                  />
                  <Tooltip title="Delete">
                    <CloseOutlined
                      style={{
                        fontSize: "30px",
                        position: "absolute",
                        right: 5,
                        top: 5,
                        color: "#c12828",
                      }}
                      onClick={() => handleDeleteCurrentFile(item)}
                    />
                  </Tooltip>
                  
                </div>
              );
            })}
      </Image.PreviewGroup> */}
        <Divider />
      {files?.length > 0 && <h4>New Files:</h4>}
      <ul>
                  {files.length > 0 &&
                    files.map((files) => {
                      return (
                        <li>
                          {" "}
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => handleDeleteFile(files.name)}
                          >
                            <DeleteIcon />
                          </IconButton>
                          {files.name}
                        </li>
                      );
                    })}
                </ul>
      {/* <Image.PreviewGroup>
        {files?.length > 0 &&
          files.map((files) => {
            return (
              <div
                style={{
                  position: "relative",
                  marginRight: "10px",
                  display: "inline-block",
                }}
              >
                <Image
                  width={200}
                  height={150}
                  style={{ padding: "5px", border: "1px solid lightgrey" }}
                  src={URL.createObjectURL(files.file)}
                />
                <Tooltip title="Delete">
                  <CloseOutlined
                    style={{
                      fontSize: "30px",
                      position: "absolute",
                      right: 5,
                      top: 5,
                      color: "#c12828",
                    }}
                    onClick={() => handleDeleteFile(files.name)}
                  />
                </Tooltip>
              </div>
            );
          })}
      </Image.PreviewGroup> */}
            
          </>

          <>
        <Alert 
        // message="Informational Notes" 
        description={
        <>
        <span>{`Next Due Date: ${dayjs(dueDateNext).format(DATE_FORMAT)}  `}</span><br/>
        <span>{`Time Due Soon Threshold: ${getThresholdDisplay(thresholdDays)} `}</span>
        </>
        } 
        type="info" 
        showIcon />
        </>
        <div
          style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}
        >
          <Button
            onClick={() => navigate("/driver_reminder")}
            danger
            size="large"
            style={{ marginRight: "10px" }}
          >
            Cancel
          </Button>
            <Button
              type="primary"
              size="large"
              onClick={handleOk}
            >
              Save
            </Button>
        </div>
        </>
      </div>
    </>
  );
};

export default ResolveDriverReminder;
